import {axiosi} from '../../config/axios'

const persistAuthUser = (user) => {
    if (user?._id) {
        localStorage.setItem('auth_user', JSON.stringify(user))
    }

    return user
}

export const signup=async(cred)=>{
    try {
        const res=await axiosi.post("auth/signup",cred)
        return persistAuthUser(res.data)
    } catch (error) {
        throw error.response.data
    }
}
export const login=async(cred)=>{
    try {
        const res=await axiosi.post("auth/login",cred)
        return persistAuthUser(res.data)
    } catch (error) {
        throw error.response.data
    }
}
export const forgotPassword=async(cred)=>{
    try {
        const res=await axiosi.post("auth/forgot-password",cred)
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
export const resetPassword=async(cred)=>{
    try {
        const res=await axiosi.post("auth/reset-password",cred)
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
export const checkAuth=async(cred)=>{
    try {
        const res=await axiosi.get("auth/check-auth")
        return persistAuthUser(res.data)
    } catch (error) {
        throw error.response.data
    }
}
export const logout=async()=>{
    try {
        const res=await axiosi.get("auth/logout")
        localStorage.removeItem('auth_user')
        return res.data
    } catch (error) {
        throw error.response.data
    }
}
